import React from "react";

function SvgIcMapPoi067(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M21.5 24a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-11.173-5c-.138 0-.208-.104-.157-.232l.482-1.207.719-1.796c.099-.246.35-.484.627-.627.167-.086.344-.138.502-.138h7c.158 0 .335.052.502.138.277.143.528.381.627.627l.719 1.796.482 1.207c.051.128-.02.232-.157.232H10.327zm.173 5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm9-10c.776 0 1.634.548 1.992 1.25l.065.143L23 19l.5.5c.248.248.455.818.493 1.331L24 21v5a1 1 0 01-.883.993L23 27h-2a1 1 0 01-.993-.883L20 26v-1h-8v1a1 1 0 01-.883.993L11 27H9a1 1 0 01-.993-.883L8 26v-5c0-.497.181-1.09.419-1.406L8.5 19.5 9 19l1.443-3.607c.289-.72 1.116-1.314 1.9-1.386L12.5 14h7zm-13-1a.5.5 0 110 1 .5.5 0 010-1zm19.11 0a.5.5 0 110 1 .5.5 0 010-1zM13 8v4h-2V8h2zm4 0v4h-2V8h2zm4 0v4h-2V8h2zM7.5 10a.5.5 0 110 1 .5.5 0 010-1zm17.11 0a.5.5 0 110 1 .5.5 0 010-1zM5.611 8a.5.5 0 11-.001 1.002A.5.5 0 015.61 8zM26.5 8a.5.5 0 11-.002 1.002A.5.5 0 0126.5 8zM16.005 4c1.481 0 3.024.717 3.868 1.822L20 6h-8c.808-1.206 2.445-2 4.005-2z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi067;
